import React, { Component } from 'react';
import { Spin } from 'antd';
import { inject, observer } from 'mobx-react';
import { getUrlQueryString } from '../../utils';
import auth from '../../utils/auth';
@inject('accountStore')
@observer
class Callback extends Component {
  async validateURI(){
    const { accountStore } = this.props
    let code = getUrlQueryString('code');
    if(code){
      accountStore.validateCode(code)
    }
  };

  componentDidMount() {
    auth.captureHarnessRedirect()
    this.validateURI();
  }

  render() {
    return (
      <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%' }}>
        <Spin style={{ position: 'absolute', top: '50%', left: '50%' }} size="large" />
      </div>
    );
  }
}
export default Callback

